module.exports = __webpack_public_path__ + "static/media/power_connection@2x.2e1db363.png";